export default () => {
  window.location.reload();
};
